import { createContext, useContext } from 'react';

interface PlaybackContextValue {
  useFullVideoDuration: boolean;
  onVideoEnded?: () => void;
  /**
   * The video cannot be played and retrying has been exhausted.
   *
   * On a "play the whole video" page the ONLY thing that advances the playlist
   * is `ended`, and a video that never loads never fires it. Without this the
   * playlist sits on a dead page indefinitely — measured in production on
   * display 20, where a morning power-on raced the network, the load failed
   * with MEDIA_ERR_NETWORK, and the screen stayed blank until someone
   * restarted it by hand.
   */
  onVideoFailed?: () => void;
  /** First frames are really playing — used to cancel the start watchdog. */
  onVideoPlaying?: () => void;
}

const PlaybackContext = createContext<PlaybackContextValue>({
  useFullVideoDuration: false,
});

export const PlaybackProvider = PlaybackContext.Provider;
export const usePlaybackContext = () => useContext(PlaybackContext);
